<template>
  <div class='relative bg-white-90 rounded z-20 m-1 p-2' data-html2canvas-ignore>
    <div
      class="p-2 transition-all transition-500"
      :class="collapsed ? 'w-10vw' : 'w-20vw'">
      <div>
        <h3 class="text-sm text-center border-b border-b-grey-500 pb-2">
          <TransitionText :text=name />
        </h3>
        <div class="flex justify-between transition-all transition-2s pt-2 pb-2" :class="zone ? 'max-h-200' : 'max-h-0'">
          <h4 class="text-xs"><TransitionText :text=variable /></h4>
          <h4 class="text-xs"><TransitionText :text="number | formatNumber" /></h4>
        </div>
      </div>
      <div v-if="top_n" class="border-t pt-2 pb-2 border-t-grey-500 text-xs">
        <span class="mb-1">Top <strong>{{ top_n.field_name }}</strong></span>
        <div class="w-full flex justify-between mt-1" v-for="item in top_n.data" :key="item.name">
          <div>
            <TransitionText v-if="item.name" :text=item.name />
            <span v-else><strong>no info/blank</strong></span>
          </div>
          <div class="text-right">
            <TransitionText :text="item.occurences | formatNumber" />
          </div>
        </div>
      </div>
      <div
        class="transition-all transition-500 overflow-hidden"
        :class="collapsed ? 'max-h-0' : 'max-h-x'">
        <simplebar class="max-h-x pr-3 border-t border-t-grey-500" data-simplebar-auto-hide="false">
          <div class="text-xs max-h-x">
            <div class="w-full flex justify-between mt-1" v-for="property in properties" :key="property.name">
              <div>
                <TransitionText :text=property.name />
              </div>
              <div class="text-right">
                <TransitionText v-if="property.value" :text="property.value | formatNumber" />
                <span v-else><strong>no info</strong></span>
              </div>
            </div>
          </div>
        </simplebar>
      </div>
      <!-- This mess down here is the little pink corner -->
      <div
        v-on:click=uncollapse()
        class="absolute bottom-0 left-0 rounded-bl border-l-2 border-b-2 w-8 h-8 transition-all transition-50
          border-pink-500 cursor-pointer
          hover:border-pink-400 hover:border-b-4 hover:border-l-4">
      </div>
    </div>
  </div>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import TransitionText from './TransitionText.vue';
import { EventBus } from '../event-bus';

export default {
  data() {
    return {
      collapsed: true,
    };
  },
  props: {
    zone: {
      type: Object,
    },
  },
  components: {
    TransitionText,
    simplebar,
  },
  computed: {
    name() {
      return (this.zone && this.zone.name) || 'Click a zone';
    },
    variable() {
      return (this.zone && this.zone.variable) || '';
    },
    number() {
      return (this.zone && this.zone.number) || '';
    },
    top_n() {
      return this.zone && this.zone.top_n;
    },
    properties() {
      const result = [];
      if (this.zone) {
        const excludedFields = [
          'name',
          'variable',
          'id',
          'number',
          'index',
          'top_n',
          this.zone.variable
        ];
        Object.keys(this.zone).forEach((key) => {
          if (!(excludedFields.find(field => key === field))) {
            result.push({
              name: key,
              value: this.zone[key],
            });
          }
        });
      }
      return result;
    },
  },
  methods: {
    setupEvents() {
      const that = this;
      EventBus.$on('clickCountry', () => {
        that.collapsed = false;
      });
    },
    uncollapse() {
      this.collapsed = !this.collapsed;
    },
  },
  mounted() {
    this.setupEvents();
  }
};
</script>

<style lang="stylus">
.max-h-0
  max-height 0px;

.max-h-200
  max-height 200px;

.max-h-x
  max-height 30vh

.w-10vw
  width 15vw

.w-20vw
  width 20vw
</style>
